










import { Component, Mixins, Prop } from "vue-property-decorator";
import { PostalCode } from "../../../domain/contact";
import { ModelEditableMixin } from "../../system/mixins";

@Component({
  components: {
  },
})
export default class PostalCodeInput extends Mixins(ModelEditableMixin) {
  @Prop({ default: false })
  shouldInputPrefix: boolean;

  @Prop()
  pick: (postalCode: string) => Promise<string>;

  $refs!: {
    postalCodeInput: HTMLInputElement,
  };

  data(): any {
    return {
      isPicking: false,
    };
  }
  isPicking: boolean;

  get isPickerEnable(): boolean {
    return !!this.pick;
  }

  get isPickable(): boolean {
    return this.isPickerEnable
        && this.editingSource
        && PostalCode.isValid(this.editingSource, this.shouldInputPrefix ? 3 : 7);
  }

  pickCodes(): void {
    this.isPicking = true;
    this.pick(this.editingSource)
      .then(c => {
        if (c !== undefined) {  // キャンセル.
          this.editingSource = (c && PostalCode.isValid(c))
            ? PostalCode.format(c)
            : c;
        }
        this.isPicking = false;
      })
      .catch(e => {
        this.$error(
          "郵便番号検索失敗",
          "郵便番号検索中にエラーが発生しました。",
          e,
        );
        this.isPicking = false;
      });
  }

  focusToInput(): void {
    const target = this.$refs.postalCodeInput;
    if (target) {
      target.focus();
      if (this.editingSource) {
        // カーソルを末尾にもってくる
        target.setSelectionRange(this.editingSource.length, this.editingSource.length);
      }
    }
  }
}
